import { DefaultRequest } from 'scripts/api';

class BaseRouter {
    /**
     * {string} entityName: É a entidade a qual a tela terá relacionamento
     * {object} model: É o model que será utilizado na tela
     * {object} collectionClass: É a classe da collection que será utilizado na tela
     * {string} tabSelector: É o identificador da aba, se for para abrir a nova tela
     *  na mesma aba, usar o mesmo nome da tela anterior, se não, muda para forçar uma aba nova.
     */

    entityName = '';
    model = null;
    collectionClass = App.Collections.BaseCollection;
    tabSelector = null;
    base_url = 'form';
    local_collection = "";
    crudStage = '';
    permissionDenied = false;
    closeActions = [];
    editModelId = null;
    editModelParentId = null;
    useStringID = false;
    updateTabTitle = () => undefined;

    constructor(entityName, model, collectionClass, tabSelector) {
        this.entityName = entityName;
        model && (this.model = model);
        collectionClass && (this.collectionClass = collectionClass);
        tabSelector && (this.tabSelector = tabSelector);

        this.collection = new this.collectionClass;

        App.Objects = App.Objects || {};
        App.Objects[this.entityName] = this;
    }

    list = () => {
        const definition = {
            entity: this.entityName,
            crudStation: 'index',
            cached: (entity) => {
                var layoutIndex = App.Forms[entity].layout.index;
                this.makeListScreen(layoutIndex);
                if (this.afterPopulateGrid) {
                    this.afterPopulateGrid(this);
                }
            },
            notcached: (entity) => {
                const request = new DefaultRequest({
                    url: `${this.base_url}/${entity}/index`,
                    success: (layout) => {
                        if (this.afterPopulateGrid) {
                            this.afterPopulateGrid(this);
                        }
                        App.Forms[this.entityName].layout = App.Forms[this.entityName].layout || {};
                        App.Forms[this.entityName].layout.index = layout;
                        this.makeListScreen(layout);
                    }
                });
                request.send();
            }
        };

        this.removeTreeView(
            '#Route #form_and_grid #treeViewForm',
            () => {
                Monet.Session.TreeviewRoute = {}
            }
        );

        Monet.Cache.check(definition);
    }

    setFormModel= () => {
        var model = this.model;
        if (typeof this.model === "function") {
            model = new this.model;
        }
        App.Forms[this.entityName].form.setModel(model);
    }

    form_new = (parentId, id) => {
        var that = this;

        /**
         * Required when adding a stop to a route
         */
        if (id) {
            this.editModelId = id;
            this.editModelParentId = parentId;
        } else {
            this.editModelId = parentId;
        }

        /*
         * Testa se o html base para criação do formulário foi carregado
         */
        Monet.Cache.check({
            entity: that.entityName,
            crudStation: 'new',
            cached: function (entity) {
                /*
                 * Renderiza o formulário e adiciona à aba correta, o nome da aba
                 * é sempre o nome da Entity
                 */
                that.renderForm(that.entityName, App.Forms[entity].layout["new"], "new");

                if (typeof that.afterPopulateGrid !== "undefined") {
                    that.afterPopulateGrid();
                }
            },
            notcached: function (entity) {
                /*
                 * Se o formulário não estiver no cache, faz a requisição pra chamar ele.
                 */
                const request = new DefaultRequest({
                    url: that.base_url + '/' + that.entityName + '/new',
                    success: function (layout) {
                        /*
                         * Adiciona o layout do formulário ao cache
                         */
                        App.Forms[entity].layout["new"] = layout;

                        /*
                         * Renderiza o formulário
                         */
                        that.renderForm(that.entityName, layout, "new");

                        if (typeof that.afterPopulateGrid !== "undefined") {
                            that.afterPopulateGrid();
                        }
                    }
                });
                request.send();
            }

        });

    }

    create = (callback) => {

        var that = this;

        /*
         * Chama a função que valida se todos os campos pre-requisitos
         * estão preenchidos
         */
        var form = App.Forms[that.entityName].form;

        // executa antes da validação
        if (typeof (that.beforeValidate) !== "undefined") {
            this.beforeValidate(form);
        }

        this.allow_submit = form.validate();

        // executa a validação
        if (typeof (that.onValidate) !== "undefined") {
            this.onValidate();
        }

        /*
         * Se tudo estiver preenchido, pode submeter
         */

        if (this.allow_submit.status) {

            form.triggerLoadingBtns();

            var model_to_create = form.getModel();

            var values = form.getValues();
            /*
             * Seta o json ao model preenchendo seus atributos
             */

            model_to_create.set(values);
            /*
             * Com o model populado chama o post para submeter os dados
             * para o servidor
             */

            if (typeof (this.beforeCreate) !== "undefined") {
                this.beforeCreate(model_to_create);
            }

            const saveModel = () => {
                model_to_create.save(model_to_create, {
                    success: function (model, response) {
                        if (response) {
                            if (typeof response.errorMessages === "undefined") {
                                if (typeof (callback) !== "undefined") {
                                    callback(model);
                                } else {
                                    if (typeof (that.afterCreate) !== "undefined") {
                                        that.afterCreate(model_to_create);
                                    } else {
                                        window.location = "#/" + that.entityName;
                                    }
                                }
                            } else {
                                that.createAndUpdateErrorHandler(response, true);
                            }
                        } else {
                            if (typeof (that.afterCreate) !== "undefined") {
                                that.afterCreate(model_to_create);
                            } else {
                                window.location = "#/" + that.entityName;
                            }
                        }

                        form.triggerLoadingBtns();
                    },
                    error: function (model, response) {
                        try {
                            var error = JSON.parse(response.responseText);
                            that.createAndUpdateErrorHandler(error, true);
                            if (that.afterCreateError) {
                                that.afterCreateError(response, error);
                            }

                        } catch (e) {
                            Monet.Configurations.errorNotification(null, response, null, null);
                        }

                        form.triggerLoadingBtns();
                    }
                });
            };

            if (typeof (this.beforeSave) !== "undefined") {
                this.beforeSave(saveModel);
            } else {
                saveModel();
            }
        } else {
            this.createAndUpdateErrorHandler(this.allow_submit, false);
            if (this.afterAppendErrorMessage) {
                this.afterAppendErrorMessage();
            }
        }

        return this;
    }


    createAndUpdateErrorHandler = (response, needLabelTranslation, scope_entity) => {
        var monetMessage = new Monet.Form.Messages.InlineMessage();
        if (this.entityName !== "") {
            if (typeof (this.entityName) !== "undefined") {
                if (this.entityName === "Stop") {
                    monetMessage.setScope("#Route");
                } else {
                    monetMessage.setScope("#" + this.entityName);
                }
            }
        } else {
            monetMessage.setScope("#" + scope_entity);
        }

        monetMessage.setInfoType("error");
        monetMessage.setMessage(response);
        monetMessage.triggerMessage();
    }

    edit = (parentId, id) => {

        this.editModel = this.model;

        if (typeof this.model === 'function') {
            this.editModel = new this.model;
        }

        if (id) {
            this.editModelId = id;
            this.editModelParentId = parentId;
        } else {
            id = parentId;
            this.editModelId = parentId;
        }

        var that = this;
        var callSetValuesToFormInputs =  (model) => {
            var entity = this.entityName;
            if( !model ) {
                alert ( Monet.I18n.getResourcesByKey('entity.not.found') );
                window.location = `#/${entity}`;
                return;
            }

            if (this.beforePopulateForm) {
                this.beforePopulateForm(model);
            }

            var form = App.Forms[entity].form;
            form.setModel(model).populateFields().disableFields();

            if (this.afterPopulateForm) {
                this.afterPopulateForm(model);
            }
        };

        /*
         * Testa se o formulário no cache
         */

        Monet.Cache.check({
            entity: that.entityName,
            crudStation: 'edit',
            cached: function (entity) {
                that.renderForm(that.entityName, App.Forms[entity].layout.edit, "edit");
                that.checkLocalCollection(id, callSetValuesToFormInputs);
            },

            notcached: function (entity) {
                const request = new DefaultRequest({
                    url: that.base_url + '/' + that.entityName + '/edit',
                    success: function (layout) {
                        App.Forms[entity].layout.edit = layout;
                        that.renderForm(that.entityName, layout, "edit");
                        that.checkLocalCollection(id, callSetValuesToFormInputs);
                    },
                    error: function (e) {
                        that.createAndUpdateErrorHandler(e);
                    }
                });
                request.send();
            }
        });
    }

    /**
     *
     * @param {Integer} id ID do elemento a ser recuperado no Collection
     * @param {Function} callback Função que será executada depois de chacagem
     */
    checkLocalCollection = (id, callback) => {
        var that = this;
        this.collection.reset();
        var projectionBuilder;
        var pageLayout = App.Forms[this.entityName].layout.index;

        if (pageLayout) {
            projectionBuilder = new Monet.Builder.Projection();
            projectionBuilder.setLayout(pageLayout);
            projectionBuilder.parseLayout();
            projectionBuilder.setOrders(App.Forms[this.entityName].columnToOrders);
            projectionBuilder.setPagination(App.Forms[this.entityName].pagination);
        }

        var pageLayoutNewOrEdit = App.Forms[this.entityName].layout['new'] || App.Forms[this.entityName].layout['edit'];
        var projectionBuilderNewOrEdit = new Monet.Builder.Projection();
        projectionBuilderNewOrEdit.setLayout(pageLayoutNewOrEdit);
        projectionBuilderNewOrEdit.parseLayout();

        if (pageLayout) {
            projectionBuilderNewOrEdit.projection.fields = projectionBuilderNewOrEdit.projection.fields.concat(
                projectionBuilder.projection.fields
            );
        }

        if (that.afterLoadData) {
            that.afterLoadData();
        }

        pageLayoutNewOrEdit = App.Forms[this.entityName].layout.new || App.Forms[this.entityName].layout.edit;
        projectionBuilderNewOrEdit = new Monet.Builder.Projection();
        projectionBuilderNewOrEdit.setLayout(pageLayoutNewOrEdit);
        projectionBuilderNewOrEdit.parseLayout();

        if (pageLayout) {
            projectionBuilderNewOrEdit.projection.fields = projectionBuilderNewOrEdit.projection.fields.concat(
                projectionBuilder.projection.fields
            );
        }

        this.projection = pageLayoutNewOrEdit?.projection ? pageLayoutNewOrEdit.projection : projectionBuilderNewOrEdit.projection.toString();

        this.collection.reset();
        this.beforePopulateLocalCollection && this.beforePopulateLocalCollection();
        const filter = (this.filterToEdit) ? this.filterToEdit(id) : {
            criteriaChain: [
              {
                and: [
                  {
                    attr: "id",
                    eq: id
                  }
                ]
              }
            ]
          };
        this.collection.filterWithCriteria({
            criteria: this.projection,
            filter: JSON.stringify(filter),
            success: () => {
                const itemId = this.useStringID ? id : parseInt(id);
                const item =  this.collection.getById(itemId);
                if (that.beforeRenderDataToForm) {
                    that.beforeRenderDataToForm(item, callback);
                } else {
                    callback(item);
                }
                if (that.afterLoadData) {
                    that.afterLoadData();
                }
            }
        });
    }

    update = (callback) => {
        var that = this;
        var form = App.Forms[that.entityName].form;

        // executa antes da validação
        if (typeof (that.beforeValidate) !== "undefined") {
            this.beforeValidate(form);
        }

        this.updateModel = form.getModel();
        this.allow_submit = form.validate();
        this.form_edit = form.getValues();

        // executa a validação
        if (typeof (this.onValidate) !== "undefined") {
            //importante, pois serve para montar o json de IPRange Profile
            this.onValidate(this.form_edit);
        }

        if (this.allow_submit.status) {
            form.triggerLoadingBtns();

            for (var key in this.updateModel.attributes) {
                if (!(key in this.form_edit) && key !== "id") {
                    this.updateModel.unset(key);
                }
            }

            if (typeof (this.beforeUpdate) !== "undefined") {
                this.beforeUpdate(this.form_edit);
            }

            this.updateModel.set({ "id": this.form_edit.id });
            const saveModel = () => {
                this.updateModel.save(this.form_edit, {
                    success: function (model, response) {
                        form.triggerLoadingBtns();

                        if (response) {
                            if (typeof response.errorMessages === "undefined") {
                                if (typeof (callback) !== "undefined") {
                                    callback(model);
                                } else {
                                    if (that.afterCreate) {
                                        that.afterCreate(model);
                                    } else {
                                        window.location = "#/" + that.entityName;
                                    }
                                }
                            } else {
                                that.createAndUpdateErrorHandler(response, true);
                            }
                        } else {
                            if (typeof (that.afterCreate) !== "undefined") {
                                that.afterCreate(model);
                            } else {
                                window.location = "#/" + that.entityName;
                            }
                        }
                    },
                    error: function (model, response) {
                        form.triggerLoadingBtns();

                        try {
                            var error = JSON.parse(response.responseText);
                            that.createAndUpdateErrorHandler(error, true);
                        } catch (e) {
                            Monet.Configurations.errorNotification(null, response, null, null);
                        }
                    }
                });
            };

            if (typeof (this.beforeSave) !== "undefined") {
                this.beforeSave(saveModel);
            } else {
                saveModel();
            }

        } else {
            this.createAndUpdateErrorHandler(this.allow_submit);
        }

        return this;
    }

    destroy = (parentId, id) => {
        var that = this;
        var allowDestroy = true;

        if (typeof id === "undefined") {
            id = parentId;
        }

        this.checkLocalCollection(id, function (model) {
            if (typeof (that.beforeDestroy) !== "undefined") {
                allowDestroy = that.beforeDestroy(that, id);
            }

            if (allowDestroy) {
                this.collection.destroy(model, {
                    success: function (model, response) {
                        if (response) {
                            if (typeof response.errorMessages === "undefined") {
                                if (typeof (callback) !== "undefined") {
                                    callback(model);
                                } else {
                                    if (typeof (that.afterDestroy) !== "undefined") {
                                        that.afterDestroy(model);
                                    } else {
                                        window.location = "#/" + that.entityName;
                                    }
                                }
                            } else {
                                that.createAndUpdateErrorHandler(response, true);
                            }
                        } else {
                            if (typeof (that.afterDestroy) !== "undefined") {
                                that.afterDestroy(model_to_create);
                            } else {
                                window.location = "#/" + that.entityName;
                            }
                        }
                    },
                    error: function (model, response) {
                        that.createAndUpdateErrorHandler(JSON.parse(response.responseText), true);
                    }
                });
            }
        });
        return this;
    }

    destroyErrorHandler = (model, response, obj) => {
        var monetMessage = new Monet.Form.Messages.InlineMessage();
        monetMessage.setScope("#" + obj.entityName);
        monetMessage.setInfoType("error");
        monetMessage.setMessage(response);
        monetMessage.triggerMessage();
    }

    checkHavePermissionToOpenTab = (entity, crud) => {
        if (!crud) {
            return true;
        }

        if (entity === 'Users') {
            entity = 'USER_';
        } else {
            entity = entity.toUpperCase() + '_';
        }

        if (crud === 'new') {
            crud = 'CREATE';
        } else if (crud === 'edit') {
            crud = 'UPDATE';
        } else if (crud === 'filter') {
            crud = 'FILTER';
        } else {
            crud = 'LIST';
        }

        var keyToCheck = entity + crud;
        var keys = [];
        keys.push(keyToCheck);
        return Monet.Security.checkKeyIsEnabled(keys);

    }

    generateDatamapper = (entity, layout) => {
        var dm = new Monet.Builder.DataMapper();
        dm.setEntity(entity);
        dm.build(null, layout);
    }

    renderMonetForm = (entity, layout, tabIdSelector) => {
        var container = "#" + tabIdSelector + " #form_and_grid";
        var divContainer = document.querySelector(container);
        var form = new Monet.Builder.Form.Horizontal(layout, entity);
        form.setCrudStage(this.crudStage);

        if (divContainer) {
            const formEl = divContainer.querySelector('form');

            formEl && formEl.remove();
        }

        var formContainer = form.render();
        divContainer.appendChild(formContainer);
        form.postRender();
        if (!App.Forms[entity]) {
            App.Forms[entity] = {};
        }
        App.Forms[entity].form = form;
        return form;
    }

    renderForm = (entity, layout, crudStage) => {
        this.tabIdSelector = this.getTabIdSelector();
        this.crudStage = crudStage;
        this.updateTabTitle(layout);

        if (!this.permissionDenied) {
            Monet.Form.checkFormTemplate(this.tabIdSelector);

            if (this.beforeCreateForm) {
                this.beforeCreateForm(entity, layout, crudStage);
            }

            this.generateDatamapper(entity, layout);
            this.renderMonetForm(entity, layout, this.tabIdSelector);

            if (crudStage === 'new') {
                this.setFormModel();
            }

            if (this.afterCreateForm) {
                this.afterCreateForm(entity, layout, crudStage);
            }
        }
    }

    makeListScreen = (layout) => {
        var that          = this,
            tabIdSelector = null,
            form,
            entity        = that.entityName;

        this.collectionFilter = Monet.Grid.Utils.getFilterToSearch(that.entityName);
        this.collectionCriteria = null;
        this.crudStage = '';

        if (layout) {
            entity = layout.userInterfaceAction.userInterface.key;
            tabIdSelector = that.getTabIdSelector();
            this.updateTabTitle(layout);

            if (!this.permissionDenied) {
                Monet.Form.checkFormTemplate(tabIdSelector);
                this.generateDatamapper(entity, layout);
                form = this.renderMonetForm(entity, layout, tabIdSelector);
                if (this.beforeInitializeGrid) {
                    this.beforeInitializeGrid(form, layout);
                }
                form.initializeGrid(this.customGridActions);
                if (entity === 'LocationOverrideTimeWindow') {
                    App.Forms[entity].dataMapper.location = { id: App.Objects.LocationOverrideTimeWindow.locationId };
                }
                this.local_collection = that.collection;
                this.collectionCriteria = that.getProjectionBasedOnIndex();
                if (typeof (this.beforeList) !== "undefined") {
                    this.beforeList();
                }
                that.executeCustomFilter(that.entityName);
            }
        } else {
            //Sem informação de layout, verifique se o servidor está funcionando corretamente
            new Greenmile.Components.AlertModal("Greenmile.error.layout.notFound")
                .show();
        }
        return this;
    }

    updateGrid = (filter, callback, appendCollection) => {
        this.projection = "";
        this.collectionCriteria = "";
        this.collectionFilter = filter;
        this.projection = this.getProjectionBasedOnIndex();
        var isAppendCollection = typeof appendCollection !== "undefined" && appendCollection === true;
        if (!isAppendCollection) {
            this.collection.reset();
        }
        if (this.beforeList) {
            this.beforeList('update');
        }
        this.executeCustomFilter(this.entityName);
    }

    getProjectionBasedOnIndex = (customNamespace) => {
      const nameSpace = customNamespace || this.entityName;
      const pageLayout = App.Forms[nameSpace].layout.index;
      const projectionBuilder = new Monet.Builder.Projection();
      projectionBuilder.setLayout(pageLayout);
      projectionBuilder.parseLayout();
      projectionBuilder.setPagination(App.Forms[nameSpace].pagination);
      return projectionBuilder.projection.toString();
    }

    executeCustomFilter = (entity) => {
        var customFilter = App.Forms[entity].filterBuilder;
        if (customFilter) {
            customFilter.executeFilter();
        }
    }

    getTabIdSelector = () => this.tabSelector || this.entityName;

    batchDelete = (idsToDelete) => {
        try {
            if (typeof idsToDelete !== "undefined" && idsToDelete.length > 0) {
                App.Forms[this.entityName].pagination.first = 0;
                const grid = App.Forms[this.entityName].table;
                const ajax = new Monet.Ajax();
                ajax.url = `${this.entityName}/BatchDelete`;
                ajax.method = "post";
                ajax.data = idsToDelete;
                ajax.success = (responseText, xhr) => {
                    if (xhr.responseText === "true") {
                        grid.setSelectedRows([]);
                        this.updateGrid(this.getFilter(), Monet.Grid.addDataToGrid);
                    } else {
                        const messages = this.formatErrorMessage(responseText);
                        this.showErrorExceptionOnPopupForm(messages);
                    }
                };
                ajax.error = (xhr) => {
                    if (xhr.responseText !== "") {
                        var response = JSON.parse(xhr.responseText);
                        this.showErrorExceptionOnPopupForm(response);
                    }
                };

                if (typeof (this.beforeSendBatchDeleteRequest) !== "undefined") {
                    this.beforeSendBatchDeleteRequest(ajax);
                }

                ajax.send();
            } else {
                const error = new Monet.Exception.ReturnError(this, "No item to delete");
                error.console();
            }
        } catch (e) {
            const error = new Monet.Exception.ReturnError(this, "Error on batch delete");
            error.console();
        }
    }

    showErrorExceptionOnPopupForm = (messages) => {
        var error        = null,
            monetMessage = null,
            selector     = "#" + this.entityName,
            scopeBlock   = selector + " #form_and_grid",
            popup        = null,
            popupScope   = selector + ' .popupFormContainer',
            div          = '<div class="monetInlineAlerContainer full"></div>';

        try {
            const showErrorsOnPopupContainer = function () {
                popup = document.querySelector(popupScope);
                if (popup !== null) {
                    popup.innerHTML = div;
                    monetMessage = new Monet.Form.Messages.InlineMessage();
                    monetMessage.setScope(popupScope);
                    monetMessage.setInfoType("error");
                    monetMessage.setMessage(messages);
                    monetMessage.triggerMessage();
                }
            };

            const callbacks = {
                onAfterShowModalForm: showErrorsOnPopupContainer
            };
            const modalForm = new Monet.Form.Modal(selector, { width: 685, height: 200 }, callbacks, scopeBlock);
            modalForm.showModalForm();
        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on show error exception");
            error.console();
        }
    }

    formatErrorMessage = (responseText) => {
        const response                    = JSON.parse(responseText);
        const responseErrorMessagesLength = response.errorMessages.length;
        const messages                    = { errorMessages: [] };

        for (let i = 0; i < responseErrorMessagesLength; i++) {
            const message = Monet.I18n.getResourcesByKey(response.errorMessages[i]);
            messages.errorMessages.push(message);
        }

        return messages;
    }

    getFilter = () => {
        try {
            var entity = Monet.Utils.GetTabName();
            return Monet.Grid.Utils.getFilterToSearch(entity, "#" + entity + " #searchFilter");
        } catch (e) {
            var error = new Monet.Exception.ReturnError(this, "Error on get filter.");
            error.console();
        }
    }

    onExit = btnExit => {
      const { selector, onClick } = btnExit;
      const exitButtons = document.querySelectorAll(selector);
      const canAddOnclickEvent = exitButtons && onClick;

      if(canAddOnclickEvent) {
        exitButtons.forEach(btn => {
          btn.removeEventListener('click', onClick);
          btn.addEventListener('click', onClick);
        });
      }
    }

    removeTreeView = (selector, callback) => {
        const treeViewEl = document
          .querySelector(selector);
        if (treeViewEl) {
          treeViewEl.remove();
          callback();
        }
    };

    addCloseAction = (action) => {
        this.closeActions.push(action);
    }

    removeCloseAction = (actionToRemove) => {
        this.closeActions = this.closeActions.filter((action) => action !== actionToRemove);
    }

    onClose = () => {
        this.closeActions.forEach((action) => action());
    }
}

App.Routers.BaseRouter = BaseRouter;
